import { render, staticRenderFns } from "./digitize.vue?vue&type=template&id=3ba8577e&scoped=true"
import script from "./digitize.vue?vue&type=script&lang=js"
export * from "./digitize.vue?vue&type=script&lang=js"
import style0 from "./digitize.vue?vue&type=style&index=0&id=3ba8577e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8577e",
  null
  
)

export default component.exports